module.exports = __webpack_public_path__ + "img/close.25e8ca14.svg";